import { Signal } from '@angular/core';
import {
  ConsequencesEnum,
  ProbabilityEnum
} from '@app/components/osh/add-osh-analysis-dialog/add-osh-analysis.builder';
import { DictionaryDto } from '@app/shared/services/dtos/dictionary.dto';
import { DangerousSituationDto } from '@app/shared/services/dtos/osh/dangerous-situation.dto';
import { User } from '@app/shared/types/models/user/user.model';

export interface AddOshAnalysisDialogData {
  id: string;
  oshAnalysis?: Osh;
}

export interface EditOshAnalysisDialogData {
  id: string;
  oshAnalysis: Osh;
}

export interface SelectUsersToOshAnalysisDialogData {
  preselectedUsers: User[];
  lockedUser: User;
}

export interface CreateOrEditOshAnalysisDialogData {
  workDescription: string;
  workStartDate: string;
  workTypeId: string;
  workPossibleThreatId: string;
  path?: string;
  id?: string;
  sequence?: string;
  parentId?: string;
  dangerousSituations: CreateOshDangerousSituation[];
  assignedUserIds: string[];
}

export interface UpdateOshAnalysisDialogData {
  workDescription: string;
  workStartDate: string;
  workTypeId: string;
  workPossibleThreatId: string;
  path?: string;
  sequence?: string;
  parentId?: string;
  dangerousSituations: CreateOshDangerousSituation[];
  assignedUserIds: string[];
}

export interface CreateOshDangerousSituation {
  id?: string;
  possibleThreat: DictionaryDto;
  probability: ProbabilityEnum;
  consequences: ConsequencesEnum;
  riskLevel: string;
  remedies: DictionaryDto[];
}

export class Osh {
  public id: string;
  public companyId?: string;
  public projectId?: string;
  public taskId: string;
  public workDescription: string;
  public workStartDate: string;
  public workType: DictionaryDto;
  public workPossibleThreat: DictionaryDto;
  public dangerousSituations: DangerousSituationDto[];
  public assignedUsers: Signal<User[]>;
  public path: string;
  public sequence: number;
  public parentId: string;
  public constructor(data: Osh) {
    Object.assign(this, data);
  }
}
